"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _BaseField = _interopRequireDefault(require("./BaseField"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * NumberField.
 *
 * @param {object} props
 * @param {number} [props.min=0]
 * @param {number} [props.max=Number.MAX_SAFE_INTEGER]
 * @param {number} [props.step=1]
 * @param {function (number | string): void} props.onChange
 * @param {object} [props.InputProps={}]
 * @returns {ReactElement}
 *
 * @example
 * // TODO: Write example.
 */
var NumberField = function NumberField(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? Number.MAX_SAFE_INTEGER : _ref$max,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      onChange = _ref.onChange,
      InputProps = _ref.InputProps,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["min", "max", "step", "onChange", "InputProps"]);
  var handleOnChange = (0, _react.useCallback)(function (e) {
    var value = parseInt(e.target.value, 10);

    if (Number.isNaN(value)) {
      onChange('');
      return;
    }

    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_react["default"].createElement(_BaseField["default"], (0, _extends2["default"])({
    type: "number",
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      inputProps: {
        min: min,
        max: max,
        step: step
      }
    }),
    onChange: handleOnChange
  }, otherProps));
};

var _default = NumberField;
exports["default"] = _default;